// NATIVE

// INSTALLED

// CUSTOM
import { useDispatch } from 'react-redux';
import { AxiosAdapter } from '../commons/adapters';
import { closeSessionGlobal } from '../commons/utils';

const http = new AxiosAdapter();

export const getShiftsAllService = async () => {
  try {
    return await http.get<any>(`/v1/shifts`);
  } catch (error: any) {
    if (error.code === 403) {
      await closeSessionGlobal();
      window.location.href = '/';
    }
    console.log('tonkaaaaaaaaaaaaaaaaaa getShiftsAllService ', error);
  }
};

export const getAllShiftsByPaginateService = async (page: number) => {
  try {
    return await http.get<any>(`/v1/shifts?page=${page}&take=10`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('tonkaaaaaaaaaaaaaaaaaa getAllShiftsByPaginateService ', error);
  }
};

export const createShiftService = async (turno: object, setPercentajeCreateTurno: any) => {
  try {
    return await http.post<any>(`/v1/shifts`, turno, setPercentajeCreateTurno);
  } catch (error: any) {
    if (error.code === 403) {
      await closeSessionGlobal();
      window.location.href = '/';
    }
    console.log('tonkaaaaaaaaaaaaaaaaaa getShiftsAllService ', error);
  }
};

export const desactiveTurnoService = async (turnoId: string) => {
  try {
    return await http.delete<any>(`/v1/shifts/${turnoId}`);
  } catch (error: any) {
    if (error.code === 403) {
      await closeSessionGlobal();
      window.location.href = '/';
    }

    console.log('tonkaaaaaaaaaaaaaaaaaa ', error);
  }
};

export const activeTurnoService = async (turnoId: string) => {
  try {
    return await http.patch<any>(`/v1/shifts/${turnoId}`);
  } catch (error: any) {
    if (error.code === 403) {
      await closeSessionGlobal();
      window.location.href = '/';
    }

    console.log('tonkaaaaaaaaaaaaaaaaaa ', error);
  }
};

export const getTurnoDetailService = async (turnoId: string) => {
  try {
    return await http.get<any>(`/v1/shifts/${turnoId}`);
  } catch (error: any) {
    if (error.code === 403) {
      await closeSessionGlobal();
      window.location.href = '/';
    }

    console.log('tonkaaaaaaaaaaaaaaaaaa ', error);
  }
};
